import * as Yup from 'yup';
import { t } from 'i18next';

export const courseFormSchema = Yup.object().shape({
  name: Yup.string().required(t('validation.required.designation')),
  groups: Yup.array().of(Yup.string()),
  grades: Yup.array().of(Yup.string()),
  schoolYear: Yup.string().required(t('validation.required.schoolyear')),
  admins: Yup.array().of(Yup.string()).min(1, t('validation.required.admins')),
  subject: Yup.string().required(t('validation.required.subject')),
});
